import { Pipe, PipeTransform } from '@angular/core';
import { TextToNumberPipe } from '@wdx/shared/utils';
import { ArticleListItem } from '../features/articles/shared/models/article-list-item.model';

@Pipe({ name: 'articleImageUrl', standalone: false })
export class ArticleImageUrlPipe implements PipeTransform {
    transform(article: ArticleListItem): string {
        if (!article) {
            return;
        }

        const availableImages = 27;

        return (
            article.imageUrl ||
            `assets/images/article/${new TextToNumberPipe().transform(
                article.name,
                availableImages,
            )}.jpg`
        );
    }
}
